const fastSellProductRejectFormInitialValues = (fastSellProduct) => ({
  status_reject_reason : fastSellProduct?.status_reject_reason || '',
  ops_notes            : fastSellProduct?.ops_notes || ''
})


export default fastSellProductRejectFormInitialValues
